import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import { pwaAssets } from "assets/cdn";
import { Column, Container, Content, Icon, SubTitle, Title } from "./styles";
import { ActionBox } from "./ActionBox";
import { DisplayReward } from "components/DIP/types/display-item";
import { useImagePath } from "hooks/useImagePath";

export interface HomeViewProps {
	rewards?: DisplayReward[];
	onClick: () => void;
}
const HomeView = ({ rewards, onClick }: HomeViewProps) => {
	const { getImage } = useImagePath("cdn");
	const bannerIcon = getImage(pwaAssets.bannerIcon);
	const isPortrait = useMediaQuery("(orientation: portrait)");

	const info = {
		title: "Add Tiki Solitaire TriPeaks Web Shop to your device home screen",
		subtitle: "Get quick access anytime and get an AMAZING Reward!"
	};

	return (
		<Container>
			{!isPortrait && (
				<>
					<Icon src={bannerIcon} />
					<Column>
						<Title>{info.title}</Title>
						<SubTitle>{info.subtitle}</SubTitle>
					</Column>
				</>
			)}
			{isPortrait && <Title>{info.title}</Title>}
			<Content>
				{isPortrait && <Icon src={bannerIcon} />}
				<Column>
					{isPortrait && <SubTitle>{info.subtitle}</SubTitle>}
					<ActionBox rewards={rewards} onClick={onClick} />
				</Column>
			</Content>
		</Container>
	);
};

export default HomeView;
